"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-expect-error
const deserializeJsonApi = tslib_1.__importStar(require("deserialize-json-api"));
exports.default = deserializeJsonApi.deserialize;
//# sourceMappingURL=index.js.map